import { render, staticRenderFns } from "./LostRecordResultList.vue?vue&type=template&id=5ea8f514&scoped=true&"
import script from "./LostRecordResultList.vue?vue&type=script&lang=js&"
export * from "./LostRecordResultList.vue?vue&type=script&lang=js&"
import style0 from "./LostRecordResultList.vue?vue&type=style&index=0&id=5ea8f514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea8f514",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDataTable,VImg,VRow})
